import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { getAssetEditorUrl } from 'personalization-lib/utils/urls/assets';
import { jsx as _jsx } from "react/jsx-runtime";
const AssetEditorLink = ({
  assetType,
  assetId,
  strategyId,
  external = false
}) => /*#__PURE__*/_jsx(Link, {
  href: getAssetEditorUrl({
    source: assetType,
    id: Number(assetId)
  }, strategyId),
  external: external,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: `personalizationLib.shared.assetEditorLink.${assetType}`
  })
});
export default AssetEditorLink;